import React from "react";
import { FaUserAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import OffCanvas from "../../OffCanvas/OffCanvas";
import triggerOffCanvas from "../../../utils/triggerOffCanvas";
import { userMenuLinks } from "../../../data";
import MobileUserSignOut from "./sub-components/MobileUserSignOut";


const Breadcrumbs = () => {
  return (
    <>
      <div className="container-fuild users__breadcrumbs_container">
        <div className="container">
          <div className="row breadcrumbs__row">
            <div className="col-6 breadcrumbs__row_user">
              <h4 className="text-danger breadcrumbs__row_user_h4">
                SYEDA MAHAM FAHIM
              </h4>
            </div>
            <div className="col-6 breadcrumbs__row_links">
              {/* For desktop */}
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link href="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link href="/user">syedamahamfahim</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    My Info
                  </li>
                </ol>
              </nav>

              {/* For Mobile  */}
              <span
                className="breadcrumb__mobile_user_icon"
                onClick={() => triggerOffCanvas("#offcanvas-user-mobile-menu")}
              >
                <FaUserAlt />
              </span>
            </div>
          </div>
        </div>
        <OffCanvas id={"offcanvas-user-mobile-menu"} data={userMenuLinks}>
          <MobileUserSignOut />
        </OffCanvas>
      </div>
    </>
  );
};

export default Breadcrumbs;
